import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import AlbumUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/MusicService/AlbumUpdateRequest';
import AudioFileAlbumCategoryRequest from '../../../Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryRequest';
import UpdateAudioFileCategoryRequest from '../../../Spirit/Admin/Interfaces/Models/MusicService/UpdateAudioFileCategoryRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import AlbumGetDetailReponse from '../../../Spirit/Admin/Interfaces/Models/MusicService/AlbumGetDetailReponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import AlbumGetListResponse from '../../../Spirit/Admin/Interfaces/Models/MusicService/AlbumGetListResponse';
import AudioFileAlbumCategoryResponse from '../../../Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse';

export default class MusicService {
	webApiService: WebApiService;
	DeleteAlbumEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailAlbumEvent = new Events<WsResponseModelT<AlbumGetDetailReponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<AlbumGetListResponse>>>();
	UpdateAlbumEvent = new Events<WsResponseModelT<Boolean>>();
	GetCategoriesEvent = new Events<WsResponseModelT<PaginationResponseT<AudioFileAlbumCategoryResponse>>>();
	GetCategoryEvent = new Events<WsResponseModelT<AudioFileAlbumCategoryResponse>>();
	UpdateCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteCategoryEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('MusicService', 'DeleteAlbum', (res: WsResponseModelT<Boolean>) => {
			self.DeleteAlbumEvent.trigger(res);
		});
		webApiService.on('MusicService', 'GetDetailAlbum', (res: WsResponseModelT<AlbumGetDetailReponse>) => {
			self.GetDetailAlbumEvent.trigger(res);
		});
		webApiService.on('MusicService', 'GetList', (res: WsResponseModelT<PaginationResponseT<AlbumGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('MusicService', 'UpdateAlbum', (res: WsResponseModelT<Boolean>) => {
			self.UpdateAlbumEvent.trigger(res);
		});
		webApiService.on('MusicService', 'GetCategories', (res: WsResponseModelT<PaginationResponseT<AudioFileAlbumCategoryResponse>>) => {
			self.GetCategoriesEvent.trigger(res);
		});
		webApiService.on('MusicService', 'GetCategory', (res: WsResponseModelT<AudioFileAlbumCategoryResponse>) => {
			self.GetCategoryEvent.trigger(res);
		});
		webApiService.on('MusicService', 'UpdateCategory', (res: WsResponseModelT<Boolean>) => {
			self.UpdateCategoryEvent.trigger(res);
		});
		webApiService.on('MusicService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
		webApiService.on('MusicService', 'DeleteCategory', (res: WsResponseModelT<Boolean>) => {
			self.DeleteCategoryEvent.trigger(res);
		});
	}
	DeleteAlbum(id: number = 0) { 	
        this.webApiService.send('MusicService', 'DeleteAlbum' , id);
    }
	GetDetailAlbum(id: number = 0) { 	
        this.webApiService.send('MusicService', 'GetDetailAlbum' , id);
    }
	GetList(request: SearchFilterRequest = null) { 	
        this.webApiService.send('MusicService', 'GetList' , request);
    }
	UpdateAlbum(request: AlbumUpdateRequest = null) { 	
        this.webApiService.send('MusicService', 'UpdateAlbum' , request);
    }
	GetCategories(request: AudioFileAlbumCategoryRequest = null) { 	
        this.webApiService.send('MusicService', 'GetCategories' , request);
    }
	GetCategory(id: number = 0) { 	
        this.webApiService.send('MusicService', 'GetCategory' , id);
    }
	UpdateCategory(request: UpdateAudioFileCategoryRequest = null) { 	
        this.webApiService.send('MusicService', 'UpdateCategory' , request);
    }
	ChangeSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('MusicService', 'ChangeSortIndex' , request);
    }
	DeleteCategory(id: number = 0) { 	
        this.webApiService.send('MusicService', 'DeleteCategory' , id);
    }
	 // async methods
	async deleteAlbumAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteAlbum.bind(this), this.DeleteAlbumEvent)(id);
	}
	async getDetailAlbumAsync(id: number = 0): Promise<AlbumGetDetailReponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetailAlbum.bind(this), this.GetDetailAlbumEvent)(id);
	}
	async getListAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<AlbumGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAlbumAsync(request: AlbumUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateAlbum.bind(this), this.UpdateAlbumEvent)(request);
	}
	async getCategoriesAsync(request: AudioFileAlbumCategoryRequest = null): Promise<PaginationResponseT<AudioFileAlbumCategoryResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategories.bind(this), this.GetCategoriesEvent)(request);
	}
	async getCategoryAsync(id: number = 0): Promise<AudioFileAlbumCategoryResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetCategory.bind(this), this.GetCategoryEvent)(id);
	}
	async updateCategoryAsync(request: UpdateAudioFileCategoryRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateCategory.bind(this), this.UpdateCategoryEvent)(request);
	}
	async changeSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
	async deleteCategoryAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteCategory.bind(this), this.DeleteCategoryEvent)(id);
	}
}